import { render, staticRenderFns } from "./TemplatesFilters.vue?vue&type=template&id=37d1173c&"
import script from "./TemplatesFilters.vue?vue&type=script&lang=js&"
export * from "./TemplatesFilters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/c6monbi/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('37d1173c')) {
      api.createRecord('37d1173c', component.options)
    } else {
      api.reload('37d1173c', component.options)
    }
    module.hot.accept("./TemplatesFilters.vue?vue&type=template&id=37d1173c&", function () {
      api.rerender('37d1173c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/monbi/transactions/filters/TemplatesFilters.vue"
export default component.exports